"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.teaser.cta.label': 'Zadaj pytanie',
    'chat.teaser.default.prompt1.description': 'Z czego zbudowana jest atmosfera Marsa?',
    'chat.teaser.default.prompt1.text': 'Z czego zbudowana jest atmosfera Marsa?',
    'chat.teaser.default.prompt2.description': 'Jak szybko może biegać koń?',
    'chat.teaser.default.prompt2.text': 'Jak szybko może biegać koń?',
    'chat.teaser.default.prompt3.description': 'Jak wymienić przebite koło?',
    'chat.teaser.default.prompt3.text': 'Jak wymienić przebite koło?',
};
